import { render, staticRenderFns } from "./divvyAdminDashboard.vue?vue&type=template&id=68608c6a&scoped=true&"
import script from "./divvyAdminDashboard.vue?vue&type=script&lang=js&"
export * from "./divvyAdminDashboard.vue?vue&type=script&lang=js&"
import style0 from "./divvyAdminDashboard.vue?vue&type=style&index=0&id=68608c6a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68608c6a",
  null
  
)

export default component.exports